import { BaseComponent, IStateBase } from 'components/BaseComponent';
import React from 'react';
import Button from '@material-ui/core/Button/Button';
import { paymentProgressService } from 'services/PaymentProgressService';
import { IPaymentStatus } from 'interfaces/IPaymentStatus';
import { enPaymentStatus } from 'enums/enPaymentStatus';
import PaymentButtonMessage from './PaymentButtonMessage';
import { PaymentInProgress } from './PaymenteMessage/PaymentInProgress';
import PaymentError from './PaymenteMessage/PaymentError';
import { paymentService } from 'services/PaymentService';
import { ICartModel } from 'interfaces/ICartModel';

const styles = require('./paymentButton.css');

interface IState extends IStateBase {
  paymentStatus: IPaymentStatus;
  payment: ICartModel;
}

export interface IProps {
  finish: () => void;
  disabledButton: boolean;
  messageButton: string;
  singleStep?: boolean;
}

export default class PaymentButton extends BaseComponent<IState, IProps> {

  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    paymentProgressService.getPaymentProgressStatus()
      .bindComponent(this)
      .subscribe((paymentStatus: IPaymentStatus) => {
        this.setState({ paymentStatus });
      });

    paymentService
      .getCart()
      .bindComponent(this)
      .subscribe((payment) => {
        this.setState({ payment });
      });
  }

  idleState = (): void => {
    paymentProgressService.setPaymentProgressStatus({
      status: enPaymentStatus.IDLE,
      message: ''
    });
  }

  statusClassName = (): string => {
    switch (this.state.paymentStatus.status) {
      case enPaymentStatus.PROGRESS:
        return 'animationInProgress';
      case enPaymentStatus.SUCCESS:
        return 'animationSuccess';
      case enPaymentStatus.ERROR:
        return 'animationError';
      default:
        return null;
    }
  }

  render() {

    if (!this.state) {
      return null;
    }

    const { disabledButton, messageButton, finish, singleStep } = this.props;
    const { paymentStatus } = this.state;
    const statusClassName = this.statusClassName();
    const isIdle = paymentStatus.status === enPaymentStatus.IDLE;
    return (
      <div className={`${styles.component} ${!!statusClassName ? statusClassName : ''} ${!!singleStep ? 'singleStep' : ''}`} >
        <div className='chk-payment-painel'>
          <div className='chk-data'>
            {paymentStatus.status === enPaymentStatus.PROGRESS ? <PaymentInProgress /> : null}
            {paymentStatus.status === enPaymentStatus.ERROR ?
              <PaymentError
                message={paymentStatus.message}
                code={paymentStatus.code}
                idleState={this.idleState}
              />
              : null
            }
            {singleStep && paymentStatus.status === enPaymentStatus.PROGRESS ?
              <Button
                id='chk-finish-payment-button'
                fullWidth
                variant='contained'
                size='large'
                classes={{
                  label: 'paymentButtonLabel'
                }}
                color='primary'
                className='paymentButton chk-stepUser__btnFinish theme-button'
                disabled={true}
                disableFocusRipple={true}
              >
                <PaymentButtonMessage status={paymentStatus.status} message={messageButton} />
              </Button>
              : null}
          </div>
        </div>
        <Button
          id='chk-finish-payment-button'
          onClick={finish}
          fullWidth
          variant='contained'
          size='large'
          classes={{
            label: 'paymentButtonLabel'
          }}
          color='primary'
          // tslint:disable-next-line:max-line-length
          className={`paymentButton chk-stepUser__btnFinish theme-button${!!singleStep && !isIdle ? ' button__singleStep' : ''}`}
          disabled={disabledButton || !isIdle}
          disableFocusRipple={true}
        >
          <PaymentButtonMessage status={paymentStatus.status} message={messageButton} />
        </Button>
      </ div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/PaymentButton/index.tsx